angular.module('impactx.search').component('ixTenderItemActions', {
        bindings: {
            tender: '<'
        },
        controller: 'TenderItemActionsCtrl',
        controllerAs: 'actionsCtrl',
        templateUrl: 'modules/search/templates/tender-item-actions.html'
    }
);